<template>
    <div>
        <div>
            <b-modal 
            :ok-only="true"
            ok-title="Ok"
            size="lg" v-model="showModal" title="Imagem">
                <div>
                    <img :src="imageurl" alt="Image">
                </div>
                <div class="text-center">
                    <a
                        type="button"
                        class="btn btn-primary"
                        :href="imageurl"
                        target="_blank"
                    >
                        Baixar
                    </a>
                </div>
            </b-modal>
        </div>

        <div>
            <h2>Log de atividades</h2>
        </div>
        <div>
            <b-table striped hover :busy.sync="tableLoading" :items="items" :fields="fields" bordered style="border: 1px solid black;" show-empty>
                <template v-slot:empty="scope">
                    <h4 class="text-center text-info">Sem registros</h4>
                </template>
                <template v-slot:emptyfiltered="scope">
                    <h4 class="text-center text-info">Sem registros para a busca</h4>
                </template>
                
                <template v-slot:cell(active)="data">
                    {{ data.item.active ? 'Sim' : 'Não' }}
                </template>

                <template v-slot:cell(jobs)="data">
                    {{ data.item.jobs ? data.item.jobs.join(", ") : "" }}
                </template>

                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" @click="displayModal(data.item.path)">Ver imagem</b-button>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
//import axios from 'axios';
import { getUsers, deleteUser, modifyUser } from './../../configs/services';
import Swal from 'sweetalert2';
import Log from './../../models/Log';
import { apiServer } from './../../configs/enviroment';

export default {
    name: 'Users',
    data(){
        return {
            showModal: false,
            imageurl: '',
            tableLoading: false,
            items: [],
            fields: [
                {
                    key: 'username',
                    sortable: true,
                    label: 'Usuário'
                },
                {
                    key: 'action',
                    sortable: false,
                    label: 'Ação'
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    sortable: false
                }
            ],
        }
    },
    methods: {
        async fetchUsers(){
            this.items = await Log.get();
            this.tableLoading = false;
        },
        displayModal(path){
            this.showModal = true;
            this.imageurl = apiServer + path;
            console.log(this.imageurl);
        },
        downloadSVG(){

        }
    },
    mounted(){
        this.tableLoading = true;
        this.fetchUsers();
    }
}
</script>

<style>

</style>